export const strings = {
  all_medical_audit: 'Tüm Tıbbi Denetim Kayıtları',
  new_log_button: 'Yeni Günlük Ekle',
  medical_audit_log_title: 'Yeni Tıbbi Denetim Günlüğü',
  submit: 'Göndermek',
  patient_details: 'Hastanın Detayları',
  age: 'Yaş',
  month: 'Ay',
  year: 'Yıl',
  age_title: '0 hariç sadece pozitif tam sayılar',
  sex: 'Seks',
  male: 'Erkek',
  female: 'Dişi',
  company: 'Şirket',
  private: 'Özel',
  insurance: 'Sigorta',
  others: 'Diğerleri',
  visit_details: 'Ziyaret Detayları',
  visit_date: 'Ziyaret Tarihi',
  visit_date_placeholder: 'Ziyaret tarihini seçin',
  visit_type: 'Ziyaret Türü',
  new: 'Yeni',
  repeat: 'Tekrarlamak',
  change: 'Değiştirmek',
  place_of_visit: 'Ziyaret Yeri',
  company_clinic: 'Şirket Kliniği',
  hospital: 'Hastane',
  private_clinic: 'Özel Klinik',
  diagnosis_theraies: 'Tanı ve Tedaviler',
  diagnosis: 'Tanı',
  send: 'Göndermek',
  send_mail: 'Posta Gönder',
  send_excel_mail: 'Özeti E-postaya Gönder',
  search_user: 'Kullanıcı Ara',
  download: 'İndirmek',
  symptom_diagnosed: 'Belirti Teşhis Edildi',
  add_diagnosis: 'Tanı Ekle',
  therapy_medication: 'Terapi/İlaç',
  therapy_medicine: 'Terapi/Tıp',
  therapy_medicine_placeholder: 'Terapi/tıbbın ilk 3 karakterini girin',
  therapy_type: 'Terapi Türü',
  dosage_type: 'Dozaj Türü',
  dosage: 'Dozaj',
  quantity: 'Miktar',
  times_per_day: 'Günde Kaç Kez',
  daily: 'Günlük',
  period: 'Dönem (Sıklık)',
  add_therapy_medication: 'Terapi/İlaç Ekle',
  on_demand: 'İsteğe Bağlı Dozaj',
  single: 'Tek doz',
  normal: 'Normal',
  load_more: 'Daha Fazlasını Yükle',
  add_drug: 'Özel İlaç Ekle',
  manufacturer_description: 'Üretici Açıklaması (İsteğe bağlı)',
  pack_description: 'Paket Açıklaması',
  PACKDESC_placeholder: 'İlaç adını girin',
  MANFDESC_placeholder: 'Üretici Açıklamasını Girin',
  product_description: 'Ürün Açıklaması',
  PRODDESC_placeholder: 'Ürün Açıklamasını Girin',
  symptoms_placeholder: 'Belirtinin ilk 3 karakterini girin',
  close: 'Kapalı',
  save_changes: 'Değişiklikleri Kaydet',
  save: 'Kaydetmek',
  view_details: 'Ayrıntıları Görüntüle',
  age_placeholder: 'Girmek',
  times_placeholder: 'örneğin 1',
  remove: 'Kaldırmak',
  medical_code: 'Tıbbi Kod',
  add_new_user: 'Yeni Kullanıcı Ekle',
  mebos_id: 'Mebos Kimliği',
  onboard_medical_user: 'Gemide Tıbbi Kullanıcı',
  create_user: 'Kullanıcı Oluştur',
  first_name: 'İlk adı',
  last_name: 'Soy isim',
  msg_success: 'Veriler başarıyla kaydedildi!!',
  msg_continue: 'Yeni tıbbi denetim kayıtları oluşturmak ister misiniz?',
  continue: 'Devam etmek',
  msg_failure: 'Bir şeyler ters gitti!!',
  go_back: 'Geri gitmek',
  email: 'E-posta',
  speciality: 'Uzmanlık',
  gender: 'Cinsiyet',
  contact_number: 'İletişim Numarası',
  copy_password: 'Şifreyi Kopyala',
  copy_password_reference: 'Referansınız için şifrenizi kopyalayın',
  dublicate_medicine: 'Terapi/Tıp kopyalanamaz',
  empty_symptom: 'Tanı/Belirti boş olamaz',
  number_boxes: 'Kutu Sayısı',
  mode_of_treatment: 'Tedavi Yöntemi',
  in_person: 'Şahsen',
  teleconsultation: 'Telekonsültasyon',
  visit_on: 'Ziyaret Et',
  at: 'de',
  female_old: 'Eskimiş',
  male_old: 'Eskimiş',
  added_on: 'Eklendi',
  upload_drugs: 'İlaçları Yükle',
  upload_drugs_label: 'İlaç Listesini Yükle (Sadece Excel dosyası)',
  upload_placeholder: 'Bir ek yükleyin',
  country: 'Ülke',
  download_template: 'Şablonu İndir',
  success_message: 'Veriler başarıyla yüklendi',
  failure_message: 'Bir şeyler ters gitti',
  upload_diagnosis: 'Tanı Yükleme',
  start_date_ma: 'Tıbbi Denetim Başlangıç Tarihi',
  end_date_ma: 'Tıbbi Denetim Bitiş Tarihi',
  start_date_placeholder: 'Başlangıç Tarihini Girin',
  end_date_placeholder: 'Bitiş Tarihini Girin',
  upload_symptoms_label: 'Belirti Listesini Yükle (sadece Excel dosyası)',
  mebos_id_label: '(birden fazla kimlik için lütfen enter tuşunu kullanın)',
  optional: '(İsteğe bağlı)',
  create_password: 'Şifre oluşturmak için adınızı ve soyadınızı girin',
  errors: {
    year_required: 'Yıl gereklidir',
    month_required: 'Ay gerekli',
    age_zero: 'Yaş sıfır olmamalı',
    fname_required: 'Ad gereklidir',
    lname_required: 'Soyadı gereklidir',
    phone_required: 'İletişim Numarası gereklidir',
    mebos_id_required: 'Mebos kimliği gereklidir',
    medical_code_reuired: 'Tıbbi Kod gereklidir',
    email_required: 'E-posta gereklidir',
    incorrect_email: 'E-posta biçimi doğru değil',
    date_required: 'Ziyaret Tarihi gereklidir',
    symptoms_required: 'Belirti Tanısı gereklidir',
    therapy_required: 'Terapi/İlaç gerekli',
    dosageQuantity_required: 'Dozaj gerekli',
    period_required: 'Gerekli süre',
    quantity_required: 'miktar gerekli',
    quantity_zero: 'miktar sıfır olmamalı',
    times_per_day_required: 'Günde kaç kez gereklidir',
    times_per_day_zero: 'Gündeki zaman sıfır olamaz',
    PACKDESC_required: 'Paket Açıklaması gereklidir',
    MANFDESC_required: 'Üretim Açıklaması gereklidir',
    PRODDESC_required: 'Ürün Açıklaması gereklidir',
    file_required: 'Dosya zorunludur',
    ma_enabled_start_date_error: 'Başlangıç tarihi bitiş tarihinden küçük olmalıdır',
    ma_enabled_start_date_required: 'Başlangıç tarihi gereklidir',
    ma_enabled_end_date_required: 'Bitiş tarihi gereklidir',
    country_id_required: 'Ülke gerekli',
    fname_invalid: 'Ad geçersiz karakter içermemelidir',
    lname_invalid: 'Ad geçersiz karakter içermemelidir',
  },
  no_medical_audit: 'Tıbbi denetim yok',
};